export default "__VITE_ASSET__DJyHpqcu__"